import { DimensionUnit } from '@floori-web-components';
import { AssetModel3DDto } from '../common';
import { ProductTextureGenerationStatus } from './product-status';
import { FieldTranslation } from '@floori-web-components';

export interface ProductTileSize {
    width: number;
    height: number;
    thickness: number;
    unit: DimensionUnit;
    groutId?: string;
    groutWidth: number;
    groutColor: string;
    groutUnit: string;
    groutEditable: boolean;
    prices: TilePrice[];
    isDefault: boolean;
    url?: FieldTranslation;
    originalUnit?: DimensionUnit;
    displayUnit: DimensionUnit;
    originalWidth: number;
    originalHeight: number;
    id?: string;
    sku?: string;
    model3D?: AssetModel3DDto;
    status?: ProductTextureGenerationStatus;
}

export interface TilePrice {
    price: string;
    currency: string;
    isDefault: boolean;
}

export const imperialUnits = [DimensionUnit.inch, DimensionUnit.ft];
